if (!customElements.get("article-nav-list")) {
    class ArticleNavList extends HTMLElement {
        constructor() {
            super();
            this.scrollToHeading = this.scrollToHeading.bind(this); // 绑定this
        }

        connectedCallback() {
            this.initNavList();
        }

        initNavList() {
            const navList = this.querySelector('.article-nav-list__list');
            const content = document.querySelector('.article__content');

            if (!navList || !content) {
                console.error('必需的元素未找到！');
                return;
            }

            const contentH2 = content.querySelectorAll('h2');
            navList.innerHTML = '';

            contentH2.forEach((h2, index) => {
                h2.setAttribute('data-index', index);

                const li = document.createElement('li');
                const button = document.createElement('button');
                button.className = 'article-nav-button';
                button.dataset.index = index;
                button.textContent = h2.textContent.trim();

                button.addEventListener('click', () => {
                    this.scrollToHeading(h2);
                });

                li.appendChild(button);
                navList.appendChild(li);
            });
        }

        scrollToHeading(headingElement) {
            // 获取sticky-header元素及其高度
            const stickyHeader = document.querySelector('sticky-header');
            let offset = 0;

            // 如果sticky-header存在且有.sticky类
            if (stickyHeader && stickyHeader.classList.contains('sticky')) {
                offset = stickyHeader.offsetHeight;
            }

            // 计算目标位置
            const targetPosition = headingElement.getBoundingClientRect().top + window.pageYOffset;

            // 滚动到目标位置（考虑sticky header高度）
            window.scrollTo({
                top: targetPosition - offset,
                behavior: 'smooth'
            });
        }
    }

    customElements.define("article-nav-list", ArticleNavList);
}